module.exports = __webpack_public_path__ + "static/media/TRAMITACION_SEREMI.386504a3.png";